import { render, staticRenderFns } from "./BillingUnavailable.vue?vue&type=template&id=823b636c&scoped=true&"
import script from "./BillingUnavailable.vue?vue&type=script&lang=js&"
export * from "./BillingUnavailable.vue?vue&type=script&lang=js&"
import style0 from "./BillingUnavailable.vue?vue&type=style&index=0&id=823b636c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823b636c",
  null
  
)

export default component.exports